const s = {
  name: "ExclamationMark",
  dimensions: { width: 40, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40.1 34.1" style="enable-background:new 0 0 40.1 34.1;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,21.8v-9.9h2v9.9H19z"/>
		<path class="st0" d="M20,26.9c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,26.3,19.4,26.9,20,26.9z"
			/>
		<path class="st0" d="M22.6,1.5c-1.2-1.9-4-1.9-5.1,0l-17,28.1l0,0c-1.2,2,0.2,4.6,2.6,4.6h34.1c2.3,0,3.8-2.6,2.6-4.6L22.6,1.5z
			 M19.2,2.5c0.4-0.6,1.3-0.6,1.7,0l17,28.1c0.4,0.7-0.1,1.5-0.9,1.5H3c-0.8,0-1.3-0.9-0.9-1.5l0,0L19.2,2.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as ExclamationMark
};
